module.exports = __webpack_public_path__ + "img/7.4ca11a3b.png";